// extracted by mini-css-extract-plugin
module.exports = {"quantity":"Quantity_quantity__sfyFY","icon":"Quantity_icon__2MJUb","disabled":"Quantity_disabled__rVjvC"};